import { combineReducers } from 'redux';

import PowerSchoolIntegration from './powerschool/reducer';

export default combineReducers({
  PowerSchoolIntegration,
});



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/state/reducer.js